import styled, { css } from 'styled-components';
import theme from '../styles/theme';
import Status from '../types/enum/Status';

export type CardProps = {
  theme: typeof theme;
  status?: Status;
  imageUrl?: string;
} & React.HTMLProps<HTMLDivElement>;

const Card = styled.div<CardProps>`
  width: 270px;
  height: 358px;
  background-color: inherit;
  border-radius: 4px;
  background-image: url(${({ imageUrl }) => imageUrl});
  // padding: ${({ theme }) => theme.spacing.x2};

  // ${({ theme, status }) =>
    status &&
    status !== Status.default &&
    css`
      //   border: 1px solid ${theme.color[status]};
      //
    `}
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.24));
  // box-shadow: ${({ theme, status }) => theme.shadow(2, Status.default)};
`;

Card.defaultProps = {
  status: Status.default,
};

export default Card;
